import {
  CrossoverSelectionEnum,
  Estimate,
  FacilityLevelOfCare,
  FacilityLevelOfCareWithCrossoverDays,
} from '@finpay-estimation/estimation-types';

export function sumLosDaysBeforeCrossover(
  locs: FacilityLevelOfCare[] | null | undefined
): number {
  if (!locs?.length) return 0;
  return locs.reduce((sum, loc) => {
    const days = (loc as FacilityLevelOfCareWithCrossoverDays)
      .losDaysBeforeCrossover;
    return sum + (Number(days) || 0);
  }, 0);
}

/** True when the estimate is a crossover stay with no days before the change, but still set to Before. */
export function shouldAutoSelectAfterCrossover(
  estimate: Estimate | null | undefined
): boolean {
  if (!estimate?.isPlanYearCrossover) return false;
  if (estimate.crossoverSelection !== CrossoverSelectionEnum.BEFORE) {
    return false;
  }
  const locs = estimate.facilityLevelOfCare;
  if (!locs?.length) return false;
  return sumLosDaysBeforeCrossover(locs) === 0;
}

/**
 * Picks Before/After when saving LOCs.
 * If there are no days before the policy change, use After. Keep an existing Before choice
 * when there are before-days (do not treat 0 as "missing").
 */
export function resolveCrossoverSelectionForSave(
  isPlanYearCrossover: boolean,
  selectedLocs: FacilityLevelOfCare[],
  existingSelection: CrossoverSelectionEnum | number | null | undefined
): CrossoverSelectionEnum {
  if (
    isPlanYearCrossover &&
    sumLosDaysBeforeCrossover(selectedLocs) === 0
  ) {
    return CrossoverSelectionEnum.WITH;
  }
  return (existingSelection ??
    CrossoverSelectionEnum.WITH) as CrossoverSelectionEnum;
}
